import * as AuthActions from 'core/services/store/auth/actions';
import * as ProfileActions from 'core/services/store/profile/actions';
import ProfileServices from 'core/services/store/profile/services';
import changePass from 'base/defaults/forms/changePass.json';

const ProfileForm = {
  $: 'Stack',
  props: {
    direction: 'column',
    spacing: 5,
  },
  children: [
    {
      $: 'GlobalFormComponent',
      provide: ['userprofile', 'auth'],
      props: {
        formFields: changePass,
        onSubmit: (_, context) => (values) => {
          const [state] = context?.state?.auth || [];
          const [, dispatch] = context?.state?.userprofile || [];
          ProfileServices(dispatch, ProfileActions).updateProfile({
            id: state.user.uid,
            password: values.password,
            passwordConfirmation: values.confirmPassword,
          });
        },
      },
    },
    {
      $: 'Flex',
      provide: ['userprofile'],
      children: (_, context) => {
        const [state] = context?.state?.userprofile || [];
        return {
          $: 'Alert',
          props: {
            status: 'success',
            display: state?.success ? 'flex' : 'none',
          },
          children: [
            { $: 'AlertIcon' },
            { $: 'AlertTitle', props: { mr: 2 }, children: 'Your password has been updated' },
          ],
        };
      },
    },
  ],
};

export default ProfileForm;
